/** Frontend mirror of the backend account consent catalog (backend/consent_docs.py).

Guest booking uses `GUEST_CONSENT_DOCS` (no `dpa`). ISSUE-0205: DPA is compulsory
for registered users only.
*/
export const CONSENT_DOCS = [
  { key: 'terms', mandatory: true, url: '/terms' },
  { key: 'privacy', mandatory: true, url: '/privacy' },
  { key: 'data_processing', mandatory: true, url: '/legal/data-processing' },
  { key: 'dpa', mandatory: true, url: '/legal/dpa' },
  { key: 'third_party', mandatory: true, url: '/legal/third-party-messaging' },
  { key: 'marketing', mandatory: false, url: '/legal/marketing' },
];

export const GUEST_CONSENT_DOCS = CONSENT_DOCS.filter((d) => d.key !== 'dpa');

export const MANDATORY_KEYS = CONSENT_DOCS.filter((d) => d.mandatory).map((d) => d.key);
export const GUEST_MANDATORY_KEYS = GUEST_CONSENT_DOCS.filter((d) => d.mandatory).map((d) => d.key);
export const ALL_CONSENT_KEYS = CONSENT_DOCS.map((d) => d.key);
export const docUrl = (key) => CONSENT_DOCS.find((d) => d.key === key)?.url || '/legal';

function keysOf(docs = CONSENT_DOCS) {
  return docs.map((d) => d.key);
}

/** Build a checked map with every key in `docs` set to `value`. */
export function allConsentChecked(value = true, docs = CONSENT_DOCS) {
  return Object.fromEntries(keysOf(docs).map((k) => [k, !!value]));
}

export function allConsentsSelected(checked = {}, docs = CONSENT_DOCS) {
  return keysOf(docs).every((k) => !!checked[k]);
}

export function someConsentsSelected(checked = {}, docs = CONSENT_DOCS) {
  const keys = keysOf(docs);
  const n = keys.filter((k) => !!checked[k]).length;
  return n > 0 && n < keys.length;
}
